/**
 * The job status vocabulary, and the one rule that changes it on the schedule.
 *
 * This lives in `lib` rather than beside the hook that uses it so a test can import it without
 * pulling in the Supabase client. JOB_STATUSES is re-exported from `use-job-form` for the screens
 * that already read it from there.
 */
export const JOB_STATUSES = ['Pending', 'Scheduled', 'In-Progress', 'On-Hold', 'Completed', 'Completed-Follow-Up', 'Invoiced', 'Paid', 'Cancelled', 'Failed', 'Awaiting Approval', 'Closed']

/**
 * The status a job should carry once it has a time on the schedule.
 *
 * Two faults lived in one line in `use-schedule`. The status was written as the lower-case
 * `scheduled`, while every other writer and the Jobs status filter (`eq('status', ...)` over
 * JOB_STATUSES) use the canonical `Scheduled` — so a job moved on the schedule disappeared from
 * the one filter that should have found it. And it was written for EVERY job with a start time,
 * so correcting the hour on a Completed job quietly reopened it.
 *
 * A job that has not started yet is promoted to Scheduled. Anything further along keeps the
 * status it has: moving an hour on the calendar is not a statement about the work.
 */
export function statusAfterScheduling(current: string | null | undefined): string {
  const s = (current ?? '').trim()
  return s === '' || s.toLowerCase() === 'pending' ? 'Scheduled' : s
}
